import React from 'react';

function Index() {
  return (
    <div>home</div>
  );
}

export default Index;
